
export const WithdrawPaymentInfoNewUpload = (data) => {
    var formdata = new FormData()
    console.log(data);

    if (data.id) {
        formdata.append('id', data.id)
    }
   
    if (data.type) {
        formdata.append('type', data.type)
    }
    if(data.attachments){
        formdata.append('attachments',data.attachments.rawFile)
    }
    return formdata;
}